<template lang="pug">
.dialog_html.m-auto
  .dialog.d-flex.flex-column
    svg-icon.dialog_close_btn(iconClass="close", @click="closeClick")
    .dialog_title.d-flex.flex-column.flex-md-row.justify-content-between.align-items-md-end
      h2.i_h2_title {{ detail.Title }}
      .contact_info
        img.bg_default_gray(:src="detail.icon")
        span.i_ml_3 服務專線：0800-050-119
    .divider
    .dialog_content.i_pt_5.i_pt_md_4.i_pt_sm_8.flex-grow-1.flex-shrink-1
      .dialog_detail(v-html="detail.Detail")
    .btn_square.btn_yellow.close_btn.i_mt_10.i_sm_8(@click="closeClick") 關閉
</template>

<script>
export default {
  name: "DialogHtml",
  props: {
    detail: Object,
  },
  methods: {
    closeClick() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/dialog/dialog_html";
</style>
